import React from 'react';
import { useTranslation } from 'react-i18next';
import ProductCodeContainer from 'src/common/components/code-container/components/product-code-container';
import { setHomePage } from 'src/common/components/emerald-home-page/emerald-home-page';
import { ScannedDataHandler } from 'src/devices/scanner-operations';
import BarcodeScanningWindow from './barcode-scanning-window';
import SalesKeypad from 'src/sales-keypad/components/sales-keypad';

interface VoucherBarcodeProps {
  onCancel: () => void;
  onKeypadSubmit: (itemId: string) => void;
  onScan: ScannedDataHandler;
}

export const showVoucherBarcodePage = (props: VoucherBarcodeProps): void => {
  setHomePage(<BarcodeEntryContainer {...props} />, props.onScan);
};

const KeypadComponent: React.FC<VoucherBarcodeProps> = (
  props: VoucherBarcodeProps,
): JSX.Element => {
  return (
    <SalesKeypad
      keyboardId='voucher-barcode-container'
      dataTestIdModifier='voucher-barcode'
      keyPadSubmit={props.onKeypadSubmit}
      isKeypadVisible={true}
      disableManualWeight={true}
      disableQuantity={true}
      disableSubmitWhenNoInput={true}
      disableInstructionsLabel={true}
    />
  );
};

export const BarcodeEntryContainer: React.FC<VoucherBarcodeProps> = (
  props: VoucherBarcodeProps,
): JSX.Element => {
  const { t } = useTranslation();
  return (
    <ProductCodeContainer
      headerTitle={t('VoucherBarcodeCommand')}
      onKeypadSubmit={props.onKeypadSubmit}
      keypadComponent={<KeypadComponent {...props} />}
    >
      <BarcodeScanningWindow onCancel={props.onCancel} />
    </ProductCodeContainer>
  );
};
